import { Inter, Noto_Sans_KR } from 'next/font/google';

export const inter = Inter({ subsets: ['latin'], display: 'swap' });
export const notoSansKr = Noto_Sans_KR({ subsets: ['latin'], weight: ['400', '500', '700'], display: 'swap' });

export const interFontFamily = inter.style.fontFamily;
export const notoSansKrFontFamily = notoSansKr.style.fontFamily;
